import _extends from '@babel/runtime/helpers/extends';
import React__default, { useCallback } from 'react';
import styled, { css } from 'styled-components';
import { i as isMobile } from '../../theme/style-mixins/isMobile/isMobile-701df069.js';
import { B as BaseMenuItemMixin, M as MenuItem } from './MenuItem.styles-e7bc1e4d.js';
import { k as keys } from '../../LocalModules/storm-ui-utils/dist/esm/keyboardKeynames-04a50e15-b033061a.js';
import { T as TaktIdConsumer } from '../../TaktIdContext/TaktIdContext-f853b17a.js';
import { c as createStormTaktId } from '../../TaktIdContext/TaktIdContext.utils-39f30e88.js';

// eslint-disable-next-line @typescript-eslint/no-empty-interface

const ItemButton = /*#__PURE__*/styled('button').withConfig({
  componentId: "sc-storm-ui-30051113__sc-1nwgizh-0"
})(["", " border:0;margin:0;width:100%;", " :-internal-direct-focus,:-webkit-direct-focus{outline:none;}", ""], BaseMenuItemMixin, ({
  theme,
  disabled
}) => disabled ? css(["color:", ";cursor:not-allowed;"], theme.dropdown.item.colorDisabled) : css(["color:", ";cursor:pointer;"], theme.dropdown.item.color), isMobile(css(["", ";min-height:", ";"], ({
  theme
}) => theme.typography.mobile.base, ({
  theme
}) => theme.dropdown.item.mobile.minHeight)));
const MenuItemButton = ({
  children,
  disabled,
  onClick,
  taktId,
  taktValue,
  ...rest
}) => {
  const onKeyDown = useCallback(event => {
    const {
      key
    } = event;
    switch (key) {
      case keys.ENTER:
      case keys.SPACE:
        onClick === null || onClick === void 0 || onClick(event);
        break;
    }
  }, [onClick]);
  return /*#__PURE__*/React__default.createElement(TaktIdConsumer, {
    taktId: taktId,
    taktValue: taktValue,
    fallbackId: createStormTaktId('menu-item-button')
  }, ({
    getDataTaktAttributes
  }) => /*#__PURE__*/React__default.createElement(MenuItem, null, /*#__PURE__*/React__default.createElement(ItemButton, _extends({}, getDataTaktAttributes(), rest, {
    type: "button",
    onClick: onClick,
    onKeyDown: onKeyDown,
    disabled: disabled,
    $disabled: disabled
  }), children)));
};
MenuItemButton.defaultProps = {
  onClick: undefined
};
var MenuItemButton$1 = MenuItemButton;

export { MenuItemButton$1 as M };
//# sourceMappingURL=MenuItemButton-14bae57f.js.map
